
<div class="tracking-container">
  <span>{{ 'realizar_tracking' | translate }}</span>
  <lib-form-checkbox
    *ngIf="this.exerciseService.trackingCheck==false"
    [value]="exerciseService.trackingCheck"
    (change)="onChange(true)"
    class="check-off">
  </lib-form-checkbox>
  <lib-form-checkbox
    *ngIf="this.exerciseService.trackingCheck==true"
    [value]="exerciseService.trackingCheck"
    (change)="onChange(false)"
    class="check-on">
</lib-form-checkbox>
</div>


